import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "label"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CloseButton as DrywallCloseButton } from 'drywall';
import { IconClose } from '../Icon/index';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden';
import { CloseButtonMixin } from '../../mixins/components/CloseButtonMixin';
/**
 * An HTML `<button>` element used for closing content such as dialogs.
 *
 * @since 7.4.0
 */

export var StyledCloseButton = /*#__PURE__*/styled(DrywallCloseButton).withConfig({
  displayName: "StyledCloseButton",
  componentId: "c11n-8-81-1__sc-e9jpjf-0"
})(["", ""], CloseButtonMixin);

var CloseButton = function CloseButton(_ref) {
  var children = _ref.children,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledCloseButton, rest, children || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VisuallyHidden, null, label), /*#__PURE__*/React.createElement(IconClose, {
    size: "xs"
  })));
};

CloseButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @deprecated We are deprecating the use of aria-label given the inconsistent and buggy
   * experience that it gives screen readers, specifially Windows and NVDA.
   */
  'aria-label': PropTypes.string,

  /**
   * Used to tell screenreaders what to speak for this button.
   * This will leverage the VisuallyHidden component to allow a
   * consistent experience and solve a NVDA bug.
   */
  'label': PropTypes.string,

  /**
   * The close button content, by default a close icon.
   */
  'children': PropTypes.node
} : {};
CloseButton.defaultProps = {
  label: 'Close'
};
/** @component */

export default CloseButton;